import { ComponentProps, ReactNode } from 'react';
import { Stack, StackItem, TabProps } from '@optimus-web/core';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { PageTitle, PageTitleProps } from '../PageTitle/PageTitle';
import { Tabs } from '../Tabs/Tabs';

interface BaseProps {
    actions?: ReactNode;
    tabs?: Array<React.ReactElement<TabProps>> | React.ReactElement<TabProps>;
}

interface BreadcrumbsProps {
    breadcrumbs: ComponentProps<typeof Breadcrumbs>['breadcrumbs'];
    pageTitle?: never;
    titleSuffixSlot?: never;
}
interface PageTitleHeaderProps extends PageTitleProps {
    breadcrumbs?: never;
}

export type PageHeaderProps = BaseProps & (PageTitleHeaderProps | BreadcrumbsProps);

export const PageHeader = ({ breadcrumbs, actions, tabs, pageTitle, titleSuffixSlot }: PageHeaderProps) => (
    <Stack vertical spacing="50">
        <StackItem padding="100">
            <Stack spacing="200" itemAlignment="center" distribution="space-between">
                <Stack spacing="50">
                    {breadcrumbs != null ? (
                        <Breadcrumbs breadcrumbs={breadcrumbs} />
                    ) : (
                        <PageTitle pageTitle={pageTitle} titleSuffixSlot={titleSuffixSlot} />
                    )}
                </Stack>
                {actions ? (
                    <Stack spacing="100" itemAlignment="center">
                        {actions}
                    </Stack>
                ) : null}
            </Stack>
        </StackItem>
        {tabs ? <Tabs>{tabs}</Tabs> : null}
    </Stack>
);
